/**
 * DetailTabs — horizontal tab nav for the contract detail page.
 *
 * Stays sticky under the page header. Each tab keeps its own scroll
 * position via the parent.
 */
import React from 'react';
import { LayoutGrid, FileSignature, Factory, Truck, Receipt, Activity } from 'lucide-react';

// Manifest is post-award only. The pre-award phases (Tech Spec, Sourcing,
// Quotes) now live in FORGE, which consumes the shared sourcing backend.
export const TABS = [
  { id: 'overview',    label: 'Overview',     icon: <LayoutGrid size={14} /> },
  { id: 'contract',    label: 'Contract',     icon: <FileSignature size={14} /> },
  { id: 'production',  label: 'Production',   icon: <Factory size={14} /> },
  { id: 'logistics',   label: 'Logistics',    icon: <Truck size={14} /> },
  { id: 'invoice',     label: 'Invoice',      icon: <Receipt size={14} /> },
  { id: 'activity',    label: 'Activity',     icon: <Activity size={14} /> },
];

const DetailTabs = ({ active, onChange }) => {
  return (
    <div className="manifest-detail-tabs" role="tablist">
      {TABS.map((t) => (
        <button
          key={t.id}
          role="tab"
          aria-selected={active === t.id}
          className={`manifest-detail-tab ${active === t.id ? 'active' : ''}`}
          onClick={() => onChange(t.id)}
        >
          {t.icon}
          <span>{t.label}</span>
        </button>
      ))}
    </div>
  );
};

export default DetailTabs;
